import { render, staticRenderFns } from "./ServiceDet.vue?vue&type=template&id=5df22c7c&"
import script from "./ServiceDet.vue?vue&type=script&lang=js&"
export * from "./ServiceDet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ServiceDet.vue"
export default component.exports